import { render, staticRenderFns } from "./NumberBlock.vue?vue&type=template&id=6126d153&"
import script from "./NumberBlock.vue?vue&type=script&lang=js&"
export * from "./NumberBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports